/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockReceiveDtGrid extends Serenity.EntityGrid<IcStockReceiveDtRow,any> {
        protected getColumnsKey() { return IcStockReceiveDtColumns.columnsKey; }
        protected getDialogType() { return IcStockReceiveDtDialog; }
        protected getEditorType() { return IcStockReceiveDtEditor; }
        protected getIdProperty() { return IcStockReceiveDtRow.idProperty; }
        protected getInsertPermission() { return IcStockReceiveDtRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockReceiveDtRow.localTextPrefix; }
        protected getService() { return IcStockReceiveDtService.baseUrl; }
     
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            // Q.first(filters, x => x.field == fld.DocDate).init = w => {

            //     (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

            //     let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
            //     endDate.valueAsDate = new Date(Date.now());
            // };

            //var q = Q.parseQueryString();
            //if (q["SysDocNo"]) {
            //    var category = Q.tryFirst(filters, x => x.field == "SysDocNo");
            //    category.init = e => {
            //        e.element.getWidget(Serenity.LookupEditor).value = q["SysDocNo"];
            //    };
            //}


            return filters;

        }
        
        
      

        protected beforeLoadEntity() {
            let self = this;            
            
        }
      
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
          
         
            return buttons;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();
          
            //grid.autoSizeColumns();
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                
                aggregators: [
                   
                    new Slick.Aggregators.Sum('Qty'),
                    //new Slick.Aggregators.Sum('UnitCost'),
                    //new Slick.Aggregators.Sum('PurUnitRatio'),
                    //new Slick.Aggregators.Sum('PurUnitPrice'),
                    new Slick.Aggregators.Sum('CostValue')

                ]

            });
            return grid;
        }

    }
}